import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  setSelectedMenu,
  skillsetListApiData,
  getAvailableAgentList
} from "../../Redux/Actions/actions";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import moment from "moment";
import { TiWarningOutline } from "react-icons/ti";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import {
  ButtonGroup,
  Button,
  Stack,
  Pagination,
  Typography,
  Box,
  Drawer,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FilterListIcon from "@mui/icons-material/FilterList";
import { toaststyle } from "../../Utils/toaststyle";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
  StyledTableCell3,
} from "../../CustomComponent/TableCompoent";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    agentlistdata: state.data.agentlistdata,
    skillsetdata: state.data.skillsetdata,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const CampaignSummary = (props) => {
  const selectAgentRef = useRef(null);
  const selectSkillsetRef = useRef(null);
  const selectDispositionRef = useRef(null);
  const animatedComponents = makeAnimated();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [apiCallsMade, setApiCallsMade] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [calldetailsreportlist, setCalldetailsreportlist] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [fromDateError, setFromDateError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedagent, setSelectedagent] = useState([]);
  const [calldetailsreportspinner, setCalldetailsreportspinner] =
    useState(false);

  const handleSubmit = () => {
    if (moment(fromdate).isAfter(todate)) {
      setFromDateError(true);
      setShowFilter(true);
    } else {
      CampaignSummaryReportData();
      setFromDateError(false);
      handelCloseFilter();
    }
  };

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  useEffect(() => {
    CampaignSummaryReportData();
    props.getAvailableAgentList()
    setApiCallsMade(true);

  }, []);

  useEffect(() => {
    CampaignSummaryReportData();
  }, [page]);

  const CampaignSummaryReportData = async () => {
    setCalldetailsreportspinner(true);
    await axios
      .post(
        BaseUrl + "/users/summarycampaign",
        {
          start_date: fromdate !=="" ? fromdate : "",
          end_date: todate !==""? todate : "",
          offset: page == 1 ? 0 : (page - 1) * 10,
          agent_id: selectedagent.map((option) => option.value),
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setCalldetailsreportspinner(false);
        if (res.data.success) {
          setCalldetailsreportlist(res.data.Data);
          setPagination(res.data.count);
          setCalldetailsreportspinner(false);
        } else {
          setCalldetailsreportspinner(false);
          setCalldetailsreportlist([]);
          setPagination(0)
        }
      })

      .catch((error) => {
        setCalldetailsreportspinner(false);
        setCalldetailsreportlist([])
        setPagination(0)
        console.log(error);
      });
  };

  const CampaignSummaryReportData1 = async (ToPage1) => {
    setCalldetailsreportspinner(true);
    await axios
      .post(
        BaseUrl + "/users/summarycampaign",
        {
          start_date: fromdate !=="" ? fromdate : "",
          end_date: todate !==""? todate : "",
          agent_id: selectedagent.map((option) => option.value),
          offset: ToPage1,
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setCalldetailsreportspinner(false);
        if (res.data.success) {
          setCalldetailsreportlist(res.data.Data);
          setPagination(res.data.count);
          setCalldetailsreportspinner(false);
        } else {
          setCalldetailsreportspinner(false);
          setCalldetailsreportlist([]);
          setPagination(0)
        }
      })

      .catch((error) => {
        setCalldetailsreportspinner(false);
        setCalldetailsreportlist([])
        setPagination(0)
        console.log(error);
      });
  };

  const campaignSummaryReportDataDownload = async () => {
    setIsLoading(true);
    await axios
      .post(
        BaseUrl + "/users/summarycampaignExcel",
        {
          start_date: fromdate !=="" ? fromdate : "",
          end_date: todate !==""? todate : "",
          agent_id: selectedagent.map((option) => option.value),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((response) => {
        setIsLoading(true);
        if (response.data.status) {
          setIsLoading(false);
          let downloadEmailasPdf =
          localStorage.getItem("frontendBaseURL") + "files" + response.data.message;
          window.open(downloadEmailasPdf);

          toast.success(
            "Call Details Report Downloaded Successfully",
            toaststyle
          );
        } else {
          setIsLoading(false);
          toast.warning(response.data.message, toaststyle);
        }
      })

      .catch((error) => {
        setIsLoading(false);
        toast.warning("No Data Found", toaststyle);
      });
  };

  const handleChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const optionsAgent = props.DropDownAgentList.map((agent) => ({
    value: agent.id,
    label: agent.username,
  }));

  const handleSelectAgentChange = (selectedOptions) => {
    setSelectedagent(selectedOptions);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setTodate("");
    setFromdate("");
  };

  return (
    // Campaign Summary Report start 
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Campaign Summary Report
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>
              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={campaignSummaryReportDataDownload}
                disabled={isLoading}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {[
                      "Date ",
                      "Agent ",
                      "Campaign Name",
                      "Total Calls",
                      "Completed Calls",
                      "Pending Calls",
                    ].map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {calldetailsreportspinner ? (
                    <Stack sx={{ position: "absolute", top: "50%", left: "50%" }}>
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) :
                    //  calldetailsreportlist.length > 0 ? (
                    //   calldetailsreportlist.map((item) => {
                    //     return (
                    //       <StyledTableRow hover >
                    //         <StyledTableCell2 scope="row">
                    //           {item.date ? item.date : "--"}
                    //         </StyledTableCell2>
                    //         <StyledTableCell2>
                    //           {item.agent_name ? item.agent_name : "--"}
                    //         </StyledTableCell2>
                    //         <StyledTableCell2>
                    //           {item.CampaignName.map((item) => (
                    //             <StyledTableRow hover >
                    //               <StyledTableCell2 scope="row">
                    //                 {item.CampaignName}
                    //               </StyledTableCell2>
                    //             </StyledTableRow>
                    //           ))}
                    //         </StyledTableCell2>
                    //         <StyledTableCell2>
                    //           {item.totalCalls ? item.totalCalls : "--"}
                    //         </StyledTableCell2>
                    //         <StyledTableCell2>
                    //           {item.CampaignName.map((item) => (
                    //             <StyledTableRow hover >
                    //               <StyledTableCell2 scope="row">
                    //                 {item.callFinishedTrue}
                    //               </StyledTableCell2>
                    //             </StyledTableRow>
                    //           ))}
                    //         </StyledTableCell2>
                    //         <StyledTableCell2>
                    //           {item.CampaignName.map((item) => (
                    //             <StyledTableRow hover >
                    //               <StyledTableCell2 scope="row">
                    //                 {item.callFinishedFalse}
                    //               </StyledTableCell2>
                    //             </StyledTableRow>
                    //           ))}
                    //         </StyledTableCell2>
                    //       </StyledTableRow>
                    //     );
                    //   })
                    // ) 


                    calldetailsreportlist && calldetailsreportlist.length > 0 ? (
                      calldetailsreportlist.map((item, index) => (
                        <React.Fragment key={index}>
                          {item.CampaignName.map((campaign, campaignIndex) => (
                            <StyledTableRow key={campaignIndex}>
                              {campaignIndex === 0 && (
                                <StyledTableCell3 scope="row" className="border" rowSpan={item.CampaignName.length}>
                                  {item.date ? item.date : "--"}
                                </StyledTableCell3>
                              )}

                              <StyledTableCell3 className="border">{item.agent_name ? item.agent_name : "--"}</StyledTableCell3>
                              <StyledTableCell3 className="border">{campaign.CampaignName ? campaign.CampaignName : "--"}</StyledTableCell3>
                              <StyledTableCell3 className="border">{campaign.totalCalls ? campaign.totalCalls : "--"}</StyledTableCell3>
                              <StyledTableCell3 className="border">{campaign.callFinishedTrue ? campaign.callFinishedTrue : "--"}</StyledTableCell3>
                              <StyledTableCell3 className="border">{campaign.callFinishedFalse}</StyledTableCell3>
                            </StyledTableRow>
                          ))}
                        </React.Fragment>
                      ))
                    )

                      : (
                        // Data unavailable start
                        <Stack
                          sx={{
                            position: "absolute",
                            width: "100%",
                            height: "calc(100vh - 14rem)",
                          }}
                          justifyContent="center"
                          alignContent="center"
                        >
                          <Stack
                            className="text-muted"
                            direction="column"
                            justifyContent="center"
                            alignContent="center"
                          >
                            <span className="mx-auto">
                              <img
                                src={Nodata}
                                alt="pic"
                                style={{ width: "11rem", userSelect: "none" }}
                              />
                            </span>
                            <span className="mx-auto">
                              <h6
                                className="text-muted mt-3"
                                style={{ fontSize: "13px" }}
                              >
                                Data unavailable
                              </h6>
                            </span>
                          </Stack>
                        </Stack>
                        // Data unavailable end
                      )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing{" "}
                {Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )}{" "}
                to {Math.min(page * 10, isNaN(pagination) ? 0 : pagination)} of{" "}
                {isNaN(pagination) ? 0 : pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>
      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    From Date <small className="text-danger">*</small>
                  </label>
                  <input
                    type="date"
                    value={fromdate}
                    onChange={(e) => {
                      setFromdate(e.target.value);
                    }}
                    className="form-control"
                    id="exampleInputfromdate"
                  />
                  {fromDateError ? (
                    <span
                      className="text-danger fw-500"
                      style={{ fontSize: "10px" }}
                    >
                      From Date Should Less Than To Date
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label for="exampleInputtodate" className="form-label">
                    To Date <small className="text-danger">*</small>
                  </label>
                  <input
                    value={todate}
                    type="date"
                    onChange={(e) => {
                      setTodate(e.target.value);
                    }}
                    className="form-control"
                    id="exampleInputtodate"
                  />
                </div>


                <div className="mb-3">
                  <label for="exampleInputfromdate" className="form-label">
                    Agent <small className="text-danger">*</small>
                  </label>
                  <Select
                    ref={selectAgentRef}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    isMulti
                    options={optionsAgent}
                    placeholder="Select Agent"
                    styles={customStyles}
                    onChange={handleSelectAgentChange}
                    defaultValue={selectedagent}
                    className="fs-13"
                  />
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelCloseFilter}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (moment(fromdate).isAfter(todate)) {
                  setFromDateError(true);
                } else {
                  setFromDateError(false);
                  CampaignSummaryReportData1(0);
                  setPage(1);
                  setShowFilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </StyledPaper>
    // Campaign Summary Report end 
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  skillsetListApiData,
  getAvailableAgentList
})(CampaignSummary);
